export const LANGUAGES_LIST = [
    {
        icon: 'locale-en',
        sprite: 'locales',
        code: 'en-US',
        name: 'English',
        // rtl: true
    }, {
        icon: 'locale-zh',
        sprite: 'locales',
        code: 'zh-CN',
        name: '简体中文'
    }, {
        icon: 'locale-fr',
        sprite: 'locales',
        code: 'fr-FR',
        name: 'Français'
    }, {
        icon: 'locale-de',
        sprite: 'locales',
        code: 'de-DE',
        name: 'Deutsch'
    }, {
        icon: 'locale-it',
        sprite: 'locales',
        code: 'it-IT',
        name: 'Italiano'
    }, {
        icon: 'locale-ja',
        sprite: 'locales',
        code: 'ja-JP',
        name: '日本語'
    }, {
        icon: 'locale-pt',
        sprite: 'locales',
        code: 'pt-BR',
        name: 'Português (Brasil)'
    }, {
        icon: 'locale-ru',
        sprite: 'locales',
        code: 'ru-RU',
        name: 'Русский'
    }, {
        icon: 'locale-es',
        sprite: 'locales',
        code: 'es-ES',
        name: 'Español'
    }, {
        icon: 'locale-ko',
        sprite: 'locales',
        code: 'ko-KR',
        name: '한국어'
    }, {
        icon: 'locale-ar',
        sprite: 'locales',
        code: 'ar-AE',
        name: 'العربية',
        rtl: true
    }
]

export const ALL_LANGUAGES_LIST = [
    { "code": "ar-SA", "name": "العربية" },
    { "code": "bn-BD", "name": "বাংলা" },
    { "code": "de-DE", "name": "Deutsch" },
    { "code": "en-US", "name": "English" },
    { "code": "es-ES", "name": "Español" },
    { "code": "fa-IR", "name": "فارسی" },
    { "code": "fr-FR", "name": "Français" },
    { "code": "gu-IN", "name": "ગુજરાતી" },
    { "code": "hi-IN", "name": "हिन्दी" },
    { "code": "id-ID", "name": "Indonesia" },
    { "code": "it-IT", "name": "Italiano" },
    { "code": "ja-JP", "name": "日本語" },
    { "code": "jv-ID", "name": "Basa Jawa" },
    { "code": "ko-KR", "name": "한국어" },
    { "code": "mr-IN", "name": "मराठी" },
    { "code": "ms-MY", "name": "Melayu" },
    { "code": "pa-IN", "name": "ਪੰਜਾਬੀ" },
    { "code": "pl-PL", "name": "Polski" },
    { "code": "pt-BR", "name": "Português (Brasil)" },
    { "code": "ro-RO", "name": "Română" },
    { "code": "ru-RU", "name": "Русский" },
    { "code": "ta-IN", "name": "தமிழ்" },
    { "code": "te-IN", "name": "తెలుగు" },
    { "code": "th-TH", "name": "ไทย" },
    { "code": "tr-TR", "name": "Türkçe" },
    { "code": "uk-UA", "name": "Українська" },
    { "code": "ur-PK", "name": "اردو" },
    { "code": "vi-VN", "name": "Tiếng Việt" },
    { "code": "zh-CN", "name": "简体中文" },
    { "code": "zh-TW", "name": "繁體中文" }
]
